import { createAction } from 'typesafe-actions'
import ITyovuorolistapaketti from '../types/ITyovuorolistapaketti'

export const setTyovuorolistapaketti = createAction('TyovuorolistapakettiSet')<ITyovuorolistapaketti[]>()
